import { Injectable } from "@angular/core";
import { HttpClient, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";

// import { convertQuery } from "app/utils";

@Injectable({
  providedIn: "root",
})
export class ApiCoreService {
  constructor(private http: HttpClient) { }

  // get<ResponseType>(url: string, params?: Record<string, any>): Observable<ResponseType> {
  //   return this.http.get<ResponseType>(`${url}${convertQuery(params)}`);
  // }
  //
  // getText(url: string, params?: Record<string, any>): Observable<string> {
  //   return this.http.get(`${url}${convertQuery(params)}`, {
  //     responseType: "text",
  //   });
  // }
  //
  // getBlob(url: string, params?: Record<string, any>): Observable<HttpEvent<Blob>> {
  //   return this.http.get(
  //     `${url}${convertQuery(params)}`,
  //     { responseType: "blob", reportProgress: true, observe: "events" },
  //   );
  // }

  post<ResponseType>(url: string, body?: any, params?: Record<string, any>): Observable<ResponseType> {
    return this.http.post<ResponseType>(url, body, { params });
  }

  patch<ResponseType>(url: string, body?: Record<string, any>): Observable<ResponseType> {
    return this.http.patch<ResponseType>(url, body);
  }

  put<ResponseType>(url: string, body?: Record<string, any>): Observable<ResponseType> {
    return this.http.put<ResponseType>(url, body);
  }

  delete<ResponseType>(url: string, body?: any, params?: Record<string, any>): Observable<ResponseType> {
    return this.http.delete<ResponseType>(url, { body, params });
  }

  upload<ResponseType>(url: string, body?: any, params?: Record<string, any>): Observable<HttpEvent<ResponseType>> {
    return this.http.post<ResponseType>(
      url,
      body,
      { params, reportProgress: true, observe: "events" },
    );
  }
}
